import { Box, Card, ListItemText, Button, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { captilizeString } from '../../../common/functionUtils';
// import moment from 'moment';
import { analyticsTrackEvent } from '../../../../utils/analytics/analytics-utils';
import {
  getMemberIDCard,
  setMemberIDClean
} from '../../../../redux/memberAccounts/action';
import { setValue } from '../../../../redux/yourCareTeam/actions';
import LocalHospitalOutlined from '@mui/icons-material/LocalHospitalOutlined';
import Badge from '@mui/icons-material/Badge';
import LibraryBooks from '@mui/icons-material/LibraryBooks';
import { Group } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import CoverageDate from './CoverageDate';
import quickLinksbg from '../../../../assets/Vector.svg';
import Label from '../../../common/type/Label';
const PlanOverview = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [memberList, setMemberList] = useState([]);
  const [enrollmentsList, setEnrollmentsList] = useState([]);
  const [coveragesList, setCoveragesList] = useState([]);
  const memberAccounts = useSelector(
    state => state?.memberAccounts?.memberAccountsDetails
  );
  const medicalCard = useSelector(
    state => state?.memberAccounts?.memberIdCards
  );

  const tenantResource = useSelector(state => state.tenant.tenanantResource);
  const tenantProducts = useSelector(state => state.tenant.tenantProducts);

  useEffect(() => {
    if (medicalCard) {
      const img = `<title>Member ID Card</title>
      <div>
      <br />
      <div style="width: 600px; text-align: right" id="medicalCardId">
        <button style="padding: 10px 20px; border: 1px solid #B40F87; background: #ffffff; color: #B40F87; border-radius: 3px; corsor: pointer; text-decoration: none; margin:0 5px; outline:none" title="Click here to print" onclick="printHandler()">Print</button>
        <a style="padding: 10px 20px; border: 1px solid #B40F87; background: #ffffff; color: #B40F87; border-radius: 3px; corsor: pointer; text-decoration: none;" title="Click here to download" download="DCHP-ID-card.png" href="data:image/png;base64,${medicalCard}">Download</a></div><br /><br /><div>
        <img src="data:image/png;base64,${medicalCard}" height="800px" alt="planoverview"/>
        </div>
        <br /><br /></div>
      <script>
      function printHandler() {
        const image = '<img src="data:image/png;base64,${medicalCard}" height="800px" id="duplicateCard"  alt="planoverviewprint"/>'
        document.querySelector("#medicalCardId").style.display="none";
        window.print();
        document.querySelector("#medicalCardId").style.display="block";
      }

      </script>`;
      let element = window.open();
      element.document.write(img);
      dispatch(setMemberIDClean());
    }
  }, [medicalCard]);

  const dependentEnrollments = useSelector(state => state.dependentEnrollments);
  const selfEnrollmentsFromStore = useSelector(
    state => state?.enrollments?.enrollmentsDetails
  );

  const selfCoveragesFromStore = useSelector(
    state => state?.coverages?.coveragesDetails
  );
  const dependentCoverages = useSelector(state => state?.dependentCoverages);

  useEffect(() => {
    dispatch(setValue(null));
  }, []);
  
  useEffect(() => {
    dependentCoverages.length
      ? setCoveragesList([selfCoveragesFromStore, ...dependentCoverages])
      : setCoveragesList([selfCoveragesFromStore]);
  }, [dependentCoverages, selfCoveragesFromStore]);
  
  useEffect(() => {
    if (memberAccounts?.self || memberAccounts?.dependents)
      memberAccounts?.self
        ? setMemberList([
            { ...memberAccounts.self },
            ...memberAccounts.dependents
          ])
        : setMemberList([null, ...memberAccounts.dependents]);
  }, [memberAccounts]);
  useEffect(() => {
    dependentEnrollments.length
      ? setEnrollmentsList([selfEnrollmentsFromStore, ...dependentEnrollments])
      : setEnrollmentsList([selfEnrollmentsFromStore]);
  }, [dependentEnrollments, selfEnrollmentsFromStore]);

  const handleViewId = (groupId, subscriberId, subscriberSuffix) => {
    const { self: selfFromStore } = memberAccounts;
    let memberAccountHeader = '';
    if (selfFromStore || memberAccounts?.dependents.length) {
      memberAccountHeader = `${groupId}-${subscriberId}-${subscriberSuffix}`;
    }
    dispatch(
      getMemberIDCard(memberAccountHeader, localStorage.getItem('tenantHandle'))
    );
  };

  const getPlanDetails = subscriberId => {
    let enrollmentRecord = null;
    if (enrollmentsList.length) {
      enrollmentRecord = enrollmentsList.filter(
        data => data?.memberID === subscriberId
      )[0];
    }
    return enrollmentRecord;
  };

  const getEnrollmentDetails = async member => {
    const { subscriberId } = member;
    //add the missing numbers for the suitable handbooks
    const starMedicaidHandbook = tenantProducts.starMedicaidHandbookIds;
    const perinateNewBornHandbook = tenantProducts.perinateNewBornHandbookIds;
    const perinateMemberHandbook = tenantProducts.perinateMemberHandbookIds;
    const enrollmentRecord = getPlanDetails(subscriberId);
    //condition when no enrollment was found
    if (!enrollmentRecord) {
      return;
    }
    if (starMedicaidHandbook.includes(enrollmentRecord.classPlanID)) {
      window.open(tenantResource.starMedicaidHandbook);
    } else if (perinateNewBornHandbook.includes(enrollmentRecord.classPlanID)) {
      //give the proper handbook pdf url
      window.open(tenantResource.perinateNewBornHandbook);
      //give the proper handbook pdf url
    } else if (perinateMemberHandbook.includes(enrollmentRecord.classPlanID)) {
      window.open(tenantResource.perinateMemberHandbook);
    } else {
      /** FIXME:: need to handle not found case. One idea is to disable download button when planId not found in the records. */
    }
  };

  const getCareTeamDetails = member => {
    dispatch(setValue(member));
    setTimeout(() => {
    navigate('/careteam');
    }, 2000);
  };
  return (
    <Box className="box">
     <div className="quick-links-header" id="planoverivewsHeader">
        <div className="left-section">
          <span
            className="white-text"
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <span className="localHospitalIcon">
              <LocalHospitalOutlined />
            </span>{' '}
           <strong> <Label id="homeTitlePlanOverview"/></strong>
          </span>
        </div>
        <div className="right-section">
          <img
            src={quickLinksbg}
            alt="Quick Links Header background"
            id="planoverviewrightSectionImage"
          />
        </div>
      </div>
      <Card>
        {memberList.length === 0  ? <Box><Typography variant="h6" className='no-member-plan'>No members to display.</Typography></Box> :memberList?.map((member, index) => {
          return member?.firstName &&   <Box key={index} className="member-plan">
          <div className="member-details">
            <div className="avatar">
              {member?.firstName.charAt(0)}
              {member?.lastName.charAt(0)}
            </div>
            <ListItemText id={index} className="member-item">
              <strong className="member-name">
                {' '}
                {captilizeString(member?.firstName)}{' '}
                {captilizeString(member?.lastName)}{' '}
              </strong>
              <br />
              {getPlanDetails(member?.subscriberId)?.planDescription && 'Enrolled in '} 
              {getPlanDetails(member?.subscriberId)?.planDescription}
              <CoverageDate coverages={coveragesList[index]} />
        
          <div className="member-details member-btns">
            <Button
              variant="outlined"
              color="primary"
              id={'btn-' + member?.firstName}
              disabled={!enrollmentsList[index]?.hasMedicalInsurance}
              onClick={e => {
                e.preventDefault();
                handleViewId(
                  member?.groupId,
                  member?.subscriberId,
                  member?.subscriberSuffix
                );
                analyticsTrackEvent('idcards_IDdownload_clicked', {
                  eventCategory: 'Plan Benefits Pathing'
                });
              }}
            >
              <Badge />
              &nbsp;&nbsp;<Label id="homeTitleIDCards" />
            </Button>

            <Button
              variant="outlined"
              color="primary"
              disabled={!getPlanDetails(member?.subscriberId)}
              onClick={e => {
                e.preventDefault();
                getEnrollmentDetails(member);
                analyticsTrackEvent(
                  'benefits_coveredmembers_handbook_clicked',
                  {
                    eventCategory: 'Plan Benefits Pathing'
                  }
                );
              }}
            >
              <LibraryBooks />
              &nbsp;&nbsp;<Label id='coveredMemberTab'/>
            </Button>

            <Button
              variant="outlined"
              color="primary"
              onClick={e => {
                e.preventDefault();
                getCareTeamDetails(member);
                analyticsTrackEvent(
                  'benefits_coveredmembers_handbook_clicked',
                  {
                    eventCategory: 'Plan Benefits Pathing'
                  }
                );
              }}
            >
              <Group />
              &nbsp;&nbsp;<Label id='careTeamText'/>
            </Button>
          </div>
       
          </ListItemText>
          </div>
        </Box>;
        }
        
        )}
      </Card>
    </Box>
  );
};

export default PlanOverview;
